import React, { useContext, useEffect, useState } from 'react';
import { Form, Media } from 'react-bootstrap';
import Layout from "../../components/Layout";
import { callAPI } from "../../helper/apiUtils";
import LanguageContext from "../../helper/LanguageContext";
import { DE } from "../../Languages/DE";
import { EN } from "../../Languages/EN";
import { BASE_URL } from "../../helper/constants";
import { Link } from "react-router-dom";
import { convertBranchRole } from '../../helper/convertor';
import { Scrollbars } from "react-custom-scrollbars";
import { useSelector } from 'react-redux';
import "./CompanyFollowers.css";
const renderThumb = ({ style, ...props }) => {
  const thumbStyle = {
    borderRadius: 6,
    backgroundColor: "rgba(var(--kjuup-accent-rgb), 0.8)",
  };
  return (
    <div
      className="thumb-style"
      style={{ ...style, ...thumbStyle }}
      {...props}
    />
  );
};
const CustomScrollbars = (props) => (
  <Scrollbars
    renderThumbHorizontal={renderThumb}
    renderThumbVertical={renderThumb}
    {...props}
  />
);

function CompanyFollowers(props) {
  const { isGerm, strings } = useContext(LanguageContext)
  const [followers, setFollowers] = useState([])
  const [allFollowers, setAllFollowers] = useState([])
  const [search, setSearch] = useState("")
  const getFollowers = async () => {
    const id = props.match.params.id
    const { data } = await callAPI(`/company/${id}/follower`, {}, 'GET')
    setFollowers(data.followers)
    setAllFollowers(data.followers)
  }
  useEffect(() => {
    getFollowers();
  }, [])

  const backToUrl = () => {
    window.history.go(-1);
    return false;
  }

  const searchFollowing = async (value) => {
    setSearch(value);
    const searchResult = await allFollowers.filter((itm) => {
      if (value === "") {
        return itm;
      } else if (itm?.firstName?.toLowerCase().startsWith(value?.toLowerCase()) || itm?.lastName?.toLowerCase().startsWith(value?.toLowerCase()) ||
        itm?.fullName?.toLowerCase().includes(value?.toLowerCase())
        //    (itm?.isCompany && 
        //     itm?.fullName?.split(" ")?.find(itm=>itm?.toLowerCase()?.startsWith(value?.toLowerCase()))
        //     )
      ) {
        return itm;
      }
    });
    if (value === "") {
      setFollowers(allFollowers);
    } else {
      setFollowers(searchResult);
    }
  };

  const isDesktopResolution = useSelector(state => state.isDesktopResolution)

  return (
    <React.Fragment>
        {
          followers &&
          <div className="following follower company-followers d-flex flex-column w-100">
            <div className="main_heading company-followers__heading">
              <span 
                className="material-symbols-outlined material-arrow-left pointer company-followers__back"
                onClick={backToUrl}
              >
                keyboard_arrow_left
              </span>
              {strings.followers}
            </div>
            <div className="search company-followers__search">
              <Form.Group controlId="exampleForm.ControlInput1">
                <Form.Control
                  autocomplete="off"
                  onChange={(e) => searchFollowing(e.target.value)}
                  value={search}
                  type="search"
                  placeholder={strings.search}
                />
              </Form.Group>
            </div>
            <div className="my-scroll company-followers__scroll">
              <CustomScrollbars
                autoHide
                autoHideTimeout={500}
                autoHideDuration={200}
                className="bottom-bar"
              >
                {
                  followers &&
                  followers.map(follower => (
                    <div key={follower.id} className="post_notification">
                      <div className="my_post">
                        <Media>
                          <img
                            width={30}
                            height={30}
                            className={`mr-3 company-followers__avatar${(follower.isKjuup || follower.companies?.some(c => c.isKjuup)) ? " company-followers__avatar--internal" : ""}`}
                            src={follower.avatar ? BASE_URL + follower.avatar : process.env.PUBLIC_URL + "/assets/img/head.svg"}
                            alt="Generic placeholder"
                            onLoad={(e) => {
                              if (e.target) e.target.style.opacity = '1';
                            }}
                            onError={(e) => {
                              e.target.src = process.env.PUBLIC_URL + "/assets/img/head.svg";
                              e.target.style.opacity = '1';
                            }}
                          />
                          <Media.Body>
                            <div className="authore_name">
                              <Link to={`/user-profile/${follower.id}`}>
                                <h5>{follower.fullName}</h5></Link>
                              <p>{follower.buildingIndustryRole?.split(",")?.map((itm, index) => (index ? ", " : "") + convertBranchRole(itm, isGerm))}</p>
                            </div>
                          </Media.Body>
                        </Media>
                      </div>
                    </div>
                  ))

                }
              </CustomScrollbars>
            </div>

          </div>
        }
    </React.Fragment>
  );
}

export default CompanyFollowers;